import { useEffect, useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { UploadOutlined, IdcardOutlined } from "@ant-design/icons";

import {
  ConfigProvider,
  Space,
  Table,
  Tag,
  Input,
  Flex,
  InputNumber,
  Button,
  Alert,
  message,
  DatePicker,
  Select,
  Spin,
} from "antd";
const { TextArea } = Input;

// import { UploadOutlined, IdcardOutlined } from "@ant-design/icons"; // pastikan icon ini sudah diimport

import dayjs from "dayjs";
import formatRupiah from "@/utils/FormatRupiah";

import { ICONS } from "@/assets";
import CustomModal from "@/components/CustomModal";
import ModalAddInhouse from "@/components/CustomModals/ModalAddInhouse";
import UploadModal from "@/components/uploadModal"; // ⬅️ Sesuaikan path-nya

import { ColumnOrderList } from "../../../library/FormColumn";

import { API, URL } from "../../../config/api";

import ButtonExportPDF from "@/components/ButtonExportPDF";
import ButtonExportExcel from "@/components/ButtonExportExcel";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { createStyles } from "antd-style";
import { Link, useNavigate } from "react-router-dom";
import useRoleAccess from "@/hooks/useRoleAccess";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const orderlistDF = () => {
  const { isViewer } = useRoleAccess();
  const [branch, setBranch] = useState(null);
  const [status, setStatus] = useState(null);
  const [dateRange, setDateRange] = useState(null); // [start, end]
  const [searchText, setSearchText] = useState("");

  const branchOptions = [
    { value: "jakarta", label: "Jakarta" },
    { value: "bandung", label: "Bandung" },
    { value: "surabaya", label: "Surabaya" },
  ];

  const statusOptions = [
    { value: "new", label: "Open" },
    { value: "approved", label: "Approved" },
    { value: "reject", label: "Reject" },
  ];

  const { styles } = useStyle();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [dataPasangan, setDataPasangan] = useState([]);

  // useEffect(() => {
  //   const fetchOptions = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await API.get(URL.MASTER_ACC);
  //       const data = res.data.data;

  //       // Transformasi data agar sesuai format options Select
  //       const formattedOptions = data.map((item) => ({
  //         value: item.id,
  //         label: `${item.nameAcc} - ${item.noAcc}`,
  //         noAcc: item.noAcc,
  //         nameAcc: item.nameAcc,
  //       }));

  //       setOptions(formattedOptions);
  //     } catch (error) {
  //       console.error("Error fetching options:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchOptions();
  // }, []);

  const handleChange = (value, name) => {
    console.log("value change", value);
    console.log("name change", name);
    setSelectedData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedData(null);
    setIsAddOpen(false);
    setIsEditOpen(false);
  };

  useEffect(() => {
    console.log("type", modalType);
  }, [modalType]);

  const handleModal = (type, record) => {
    setModalType(type);
    setSelectedData(record); // Simpan data baris yang dipilih
    console.log("record", record);
  };

  const openAddModal = () => {
    setModalType(null); // Set modal untuk Add
    setIsEditOpen(false);
    setIsAddOpen(true);
    setSelectedData(null);
  };

  const openEditModal = (data) => {
    setModalType(null); // Set modal untuk Edit
    setIsAddOpen(false);
    setIsEditOpen(true);

    setSelectedData(data);
  };

  const handleSubmit = async (values) => {
    console.log("isAddOpen", isAddOpen);
    console.log("Form Submitted:", values);

    try {
      // await API.post(URL.TRX_INHOUSE + "/add", values);

      setSelectedData(null); // Update data for Edit modal
      getData();
      successMsg();
      closeModal();
      return;
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Gagal menambahkan data!");
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      const API_BASE_URL = import.meta.env.VITE_BASE_URL;
      const res = await fetch(`${API_BASE_URL}/api/pemohon/getlist-df`);
      const json = await res.json();

      // const storedUsername = localStorage.getItem("username");

      // const restrictedUsers = [
      //   // "cmo_salman",
      //   "user_df_1",
      //   "user_df_2",
      //   "user_df_3",
      //   "user_df_4",
      //   "user_df_5",
      // ];

      // const filterDataDF = json.filter((item) =>
      //   restrictedUsers.includes(item.created_by)
      // );
      setData(json);

      console.log("Data Filtered:", json);
    } catch (error) {
      console.error("Error fetching pemohon list:", error);
      // errorMsg(); // Pastikan fungsi ini ada
    } finally {
      setLoading(false);
    }
  };

  const [filterStatus, setFilterStatus] = useState(null);

  // useEffect(() => {
  //   getData();
  // }, []);

  useEffect(() => {
    if(!isViewer)
    getData();
  }, [branch, status, dateRange]);

  console.log("selectedData", selectedData);
  console.log("dataPasangan", dataPasangan);

  const optionsKategori = [
    { value: "Debit", label: "Debit" },
    { value: "Kredit", label: "Kredit" },
  ];

  const renderContent = () => {
    if (modalType === "view") {
      return (
        <>
          <Flex vertical gap={12}>
            <div className="flex gap-4">
              <div>
                <label>No. Anggota :</label>
                <Input
                  name="noAnggota"
                  value={selectedData && selectedData?.noAnggota}
                  size="large"
                  className="mt-1"
                  readOnly
                />
              </div>
              <div>
                <label>No. Simpanan :</label>
                <Input
                  name="noSimpanan"
                  value={selectedData && selectedData?.noSimpanan}
                  size="large"
                  className="mt-1"
                  readOnly
                />
              </div>
            </div>
          </Flex>
        </>
      );
    } else if (modalType === "pasangan") {
      return (
        <>
          <Flex vertical gap={12}>
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    colorPrimary: "#0164A2",
                    headerColor: "#fff",
                    headerBg: "#0164A2",
                    headerBorderRadius: 6,
                    algorithm: true,
                    // borderColor: "#000",
                  },
                  Pagination: {
                    colorPrimary: "#0164A2",
                    colorPrimaryHover: "#0164A2",
                    colorPrimaryBorder: "#0164A2",
                    algorithm: true,
                  },
                },
              }}
            >
              <Table
                className={styles.customTable}
                columns={columnDataPasangan}
                dataSource={dataPasangan}
                size="middle"
                scroll={{
                  x: "max-content",
                  // y: 55 * 5,
                }}
              />
            </ConfigProvider>
          </Flex>
        </>
      );
    }
    return null; // No form for delete modal
  };

  const actionColumn = {
    title: "Action",
    key: "action",
    fixed: "right",
    align: "center",
    // width: 100,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/approval/detail/${record.id}`}>
          <img src={ICONS.FaDetail} alt="View" />
        </Link>

        {/* <button onClick={() => openEditModal(record)}>
          <img src={ICONS.FaEdit} alt="Edit" />
        </button>

        <button onClick={() => handleModal("delete", record)}>
          <img src={ICONS.FaTrash} alt="Delete" />
        </button> */}
      </Space>
    ),
  };

  // const openDetailSimpWajibModal = (data) => {
  //   setModalType("pasangan"); // Set modal untuk Edit
  //   setSelectedData(data);
  //   setDataPasangan(data);
  //   // setTimeout(() => {
  //   // }, 500);
  // };

  const openDetailSimpWajibModal = (data) => {
    setModalType("pasangan");
    setSelectedData(data);
    // Ambil hanya data pasangan dari objek pemohon
    setDataPasangan([
      {
        namapasangan: data.namapasangan,
        nikpasangan: data.nikpasangan,
        alamatpasangan: data.alamatpasangan,
        summary_slik: data.summary_slik_pasangan,
        uri_slik: data.uri_slik_pasangan,
      },
    ]);
  };

  console.log(modalType);

  const columnDataPasangan = [
    {
      title: "NAMA",
      dataIndex: "namapasangan",
      key: "namapasangan",
      // render: (text) => <a>{text}</a>,
    },
    {
      title: "NIK",
      dataIndex: "nikpasangan",
      key: "nikpasangan",
    },
    {
      title: "ALAMAT",
      dataIndex: "alamatpasangan",
      key: "alamatpasangan",
    },
    {
      title: "SUMMARY SLIK",
      dataIndex: "summary_slik",
      key: "summary_slik",
      render: (text) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Download
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "SLIK",
      dataIndex: "uri_slik",
      key: "uri_slik",
      render: (text) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Download
          </a>
        ) : (
          "-"
        ),
    },
  ];

  const colomnMaritalStatus = {
    title: "MARITAL STATUS",
    dataIndex: "statusperkawinan",
    key: "statusperkawinan",
    render: (text, record) => (
      <button
        onClick={() => openDetailSimpWajibModal(record)}
        className="text-blue-500 underline semibold"
      >
        {text}
      </button>
    ),
  };

  // const [showUploadModal, setShowUploadModal] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState(null);

  const [uploadVisible, setUploadVisible] = useState(false);
  const [uploadData, setUploadData] = useState({
    applicationId: null,
    nik: null,
    nama: null,
    nikPasangan: null,
    namaPasangan: null,
  });

  // const handleUpload = (record) => {
  //   setSelectedRecord(record);
  //   setShowUploadModal(true);
  // };

  const handleUpload = (record) => {
    setUploadData({
      applicationId: record.application_id,
      nik: record.nik,
      nama: record.nama,
      nikPasangan: record.nikpasangan,
      namaPasangan: record.namapasangan,
    });
    setUploadVisible(true);
  };

  // const colomnuploadslik = {
  //   title: "ACTION",
  //   key: "action",
  //   render: (_, record) => {
  //     const isUploaded = !!record.uri_slik; // jika uri_slik sudah ada

  //     return (
  //         <Button
  //       type="primary"
  //       icon={<UploadOutlined />}
  //       onClick={() => handleUpload(record)}
  //       disabled={isUploaded}
  //       className={`flex items-center justify-center ${
  //         isUploaded ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500"
  //       }`}
  //       title="Upload SLIK"
  //       shape="circle"
  //     />

  //     );
  //   },
  // };

  // import { UploadOutlined, IdcardOutlined } from "@ant-design/icons"; // pastikan ini sudah diimport

  const colomnuploadslik = {
    title: "ACTION",
    key: "action",
    render: (_, record) => {
      const isUploaded = !!record.uri_slik;
      const hasFotoKTP = !!record.fotoktp || !!record.fotoktppasangan;

      const downloadKTPGabung = async () => {
        try {
          // Urutkan: KTP di atas, KTP pasangan di bawah
          // const urls = [record.fotoktp, record.fotoktppasangan].filter(Boolean);
          const API_IMAGE_BASE = "https://api1.gratama-finance.com";

          const urls = [record.fotoktp, record.fotoktppasangan]
            .filter(Boolean)
            .map((url) =>
              url.replace("http://217.196.49.162:3000", API_IMAGE_BASE)
            );

          if (urls.length === 0) {
            message.error("Tidak ada foto KTP atau KTP pasangan untuk diunduh");
            return;
          }

          // Load gambar satu per satu sesuai urutan
          const images = await Promise.all(
            urls.map(
              (url) =>
                new Promise((resolve) => {
                  const img = new Image();
                  img.crossOrigin = "anonymous";
                  img.onload = () => resolve(img);
                  img.onerror = () => {
                    console.warn(`Gagal memuat gambar: ${url}`);
                    resolve(null); // skip kalau gagal
                  };
                  img.src = url;
                })
            )
          );

          const validImages = images.filter(Boolean);
          if (validImages.length === 0) {
            message.error("Semua foto gagal dimuat");
            return;
          }

          // Tentukan ukuran canvas
          const width = Math.max(...validImages.map((img) => img.width));
          const height = validImages.reduce((sum, img) => sum + img.height, 0);

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");

          // Gambar secara vertikal sesuai urutan
          let y = 0;
          validImages.forEach((img) => {
            ctx.drawImage(img, 0, y);
            y += img.height;
          });

          // Simpan hasil gabungan
          canvas.toBlob(
            (blob) => {
              // const url = URL.createObjectURL(blob);
              if (typeof window !== "undefined" && window.URL) {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = record.nik
                  ? `KTP-${record.nik}-Gabung.jpg`
                  : "KTP-Gabung.jpg";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              }

              const a = document.createElement("a");
              a.href = url;
              a.download = record.nik
                ? `KTP-${record.nik}-Gabung.jpg`
                : "KTP-Gabung.jpg";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            },
            "image/jpeg",
            0.95
          );
        } catch (err) {
          console.error("Gagal download/gabung KTP:", err);
          message.error("Gagal mengunduh foto KTP gabungan");
        }
      };

      return (
        <Space>
          {/* Tombol Upload SLIK */}
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={() => handleUpload(record)}
            disabled={isUploaded}
            className={`flex items-center justify-center ${
              isUploaded ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500"
            }`}
            title="Upload SLIK"
            shape="circle"
          />

          {/* Tombol Download Foto KTP Gabungan */}
          {hasFotoKTP && (
            <Button
              type="default"
              icon={<IdcardOutlined />}
              onClick={downloadKTPGabung}
              title="Download Foto KTP + KTP Pasangan"
              shape="circle"
            />
          )}
        </Space>
      );
    },
  };

  const runningNumberColumn = {
    title: "No",
    key: "no",
    render: (text, record, index) =>
      (pagination.current - 1) * pagination.pageSize + index + 1,
    width: 50,
    align: "center",
  };

  const extendedColumn = [
    runningNumberColumn,
    ...ColumnOrderList.columns,
    colomnMaritalStatus,
    colomnuploadslik,
    // actionColumn,
  ];

  const [messageApi, contextHolder] = message.useMessage();

  const successMsg = () => {
    messageApi.open({
      type: "success",
      content: "Success create data",
    });
  };
  const successUpdateMsg = () => {
    messageApi.open({
      type: "success",
      content: "Success update data",
    });
  };

  const errorMsg = () => {
    messageApi.open({
      type: "error",
      content: "Data is empty",
    });
  };

  const successMsgDelete = () => {
    messageApi.open({
      type: "success",
      content: "Success delete data",
    });
  };

  const exportPDF = () => {
    // console.log(data);
    if (data != "") {
      const doc = new jsPDF();

      // Ambil header dari kolom tabel Ant Design
      const headers = ColumnOrderList.columns.map((col) => col.title);

      // Ambil data dari `dataSource`
      const body = data.map((row) =>
        // ColumnOrderList.columns.map((col) => row[col.dataIndex])
        ColumnOrderList.columns.map((col) =>
          col.dataIndex === "amount"
            ? formatRupiah(row[col.dataIndex])
            : row[col.dataIndex]
        )
      );

      // Gunakan `autoTable` untuk membuat PDF
      doc.autoTable({
        head: [headers],
        body: body,
      });

      // Simpan file PDF
      doc.save("Laporan Keuangan.pdf");
    } else {
      errorMsg();
      console.log("error");
    }
  };

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const getYearName = date.format("YYYY");
    const formattedDate = date.format("MMMM");
    // const formattedDate = date.format("MMMM-YY");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(getYearName);
    // const worksheet = workbook.addWorksheet(getMonthName);

    // Tambahkan header utama
    worksheet.mergeCells("A1:K1");
    const header1 = worksheet.getCell("A1");
    header1.value = "REKAP SLIK CONSUMER FINANCING";
    header1.font = { bold: true, size: 32 };
    header1.alignment = { horizontal: "center", vertical: "middle" };
    header1.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "A5A5A5" }, // Light blue background
    };
    header1.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.mergeCells("A2:K2");
    const header3 = worksheet.getCell("A2");
    header3.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ffffff" }, // white background
    };

    // Tambahkan sub-header dengan tanggal
    worksheet.mergeCells("A3:K3");
    const header2 = worksheet.getCell("A3");
    header2.value = getYearName;
    header2.font = { bold: true, size: 28 };
    header2.alignment = { horizontal: "center", vertical: "middle" };
    header2.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "A5A5A5" }, // Light blue background
    };
    header2.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.getRow(1).height = 25;
    worksheet.getRow(4).height = 25;

    // Tambahkan header kolom
    const headers = [
      "NO.",
      "NAMA",
      "NO. NIK",
      "TIPE PEMOHON",
      "CMO",
      "NO. SURAT",
      "NO. IDEB",
      "TGL PENGAJUAN",
      "TGL APPROVAL",
      "TUJ PERMINTAAN",
      "FOTO KTP",
    ];
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
      cell.value = header;
      cell.font = { bold: false, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "A5A5A5" }, // Light blue background
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });

    // data.forEach((item, rowIndex) => {
    //   const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
    //   row.getCell(1).value = item.nama;
    //   row.getCell(2).value = item.nik;
    //   row.getCell(3).value = item.nameAcc;
    //   row.getCell(4).value = item.created_by;
    //   row.getCell(5).value = item.kategori;
    //   row.getCell(6).value = item.amount;
    //   row.getCell(7).value = new Date(item.created_date);
    //   row.getCell(8).value = new Date(item.created_date);
    //   row.getCell(9).value = "1";
    //   row.getCell(10).value = item.fotoktp ? "Ada" : "Tidak Ada";

    //   // row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
    //   row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
    //   row.getCell(5).alignment = { horizontal: "center", vertical: "middle" };

    //   // Format untuk nilai angka (Debet, Kredit, Saldo)
    //   // row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

    //   const capitalizeText = (text) =>
    //     text?.replace(/\b\w/g, (char) => char.toUpperCase());

    //   row.getCell(4).value = row.getCell(4).value.toUpperCase();
    //   // row.getCell(4).font = { bold: true, size: 12 };

    //   const borderStyle = {
    //     top: { style: "thin" },
    //     left: { style: "thin" },
    //     bottom: { style: "thin" },
    //     right: { style: "thin" },
    //   };

    //   // Loop through cells 1 to 5 and apply the border style
    //   for (let i = 1; i <= headers.length; i++) {
    //     row.getCell(i).border = borderStyle;
    //     // row.getCell(i).value = capitalizeText(row.getCell(i).value);
    //   }
    // });

    let noCounter = 1; // mulai dari 1
    data.forEach((item, rowIndex) => {
      const startRow = 5 + worksheet.lastRow.number; // biar terus nambah baris

      // 🔹 Row utama
      let row = worksheet.addRow([
        noCounter++,
        item.nama,
        item.nik,
        "PEMOHON",
        item.created_by?.toUpperCase(),
        "-",
        "-",
        new Date(item.created_date),
        new Date(item.created_date),
        "1",
        item.fotoktp ? "ADA" : "TIDAK ADA",
      ]);

      // Format row utama
      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        if (
          colNumber === 1 ||
          colNumber === 3 ||
          colNumber === 6 ||
          colNumber === 7 ||
          colNumber === 10 ||
          colNumber === 11
        ) {
          cell.alignment = { horizontal: "center", vertical: "middle" };
        }
      });

      // 🔹 Row pasangan (kalau ada)
      if (item.namapasangan) {
        let pasanganRow = worksheet.addRow([
          noCounter++,
          item.namapasangan,
          item.nikpasangan,
          "PASANGAN",
          item.created_by?.toUpperCase(),
          "-",
          "-",
          new Date(item.created_date),
          new Date(item.created_date),
          "1",
          item.fotoktp ? "ADA" : "TIDAK ADA",
        ]);

        pasanganRow.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (
            colNumber === 1 ||
            colNumber === 3 ||
            colNumber === 6 ||
            colNumber === 7 ||
            colNumber === 10 ||
            colNumber === 11
          ) {
            cell.alignment = { horizontal: "center", vertical: "middle" };
          }
        });
      }
    });

    // Atur lebar kolom
    worksheet.columns = [
      { width: 10 },
      { width: 30 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `REKAP SLIK CF.xlsx`);
  };

  // const exportToExcel = async () => {
  //   const date = dayjs(); // Get current date
  //   const getMonthName = date.format("MMM");
  //   const formattedDate = date.format("MMM-YY");

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet(getMonthName);

  //   // Tambahkan header utama
  //   worksheet.mergeCells("A1:F1");
  //   const header1 = worksheet.getCell("A1");
  //   header1.value = "TRANSAKSI INHOUSE";
  //   header1.font = { bold: true, size: 24 };
  //   header1.alignment = { horizontal: "center", vertical: "middle" };
  //   header1.fill = {
  //     type: "pattern",
  //     pattern: "solid",
  //     fgColor: { argb: "FFBDD7EE" }, // Light blue background
  //   };
  //   header1.border = {
  //     top: { style: "medium" },
  //     left: { style: "medium" },
  //     bottom: { style: "medium" },
  //     right: { style: "medium" },
  //   };

  //   worksheet.mergeCells("A2:H2");
  //   const header3 = worksheet.getCell("A2");
  //   header3.fill = {
  //     type: "pattern",
  //     pattern: "solid",
  //     fgColor: { argb: "ffffff" }, // white background
  //   };

  //   // Tambahkan sub-header dengan tanggal
  //   worksheet.mergeCells("A3:F3");
  //   const header2 = worksheet.getCell("A3");
  //   header2.value = formattedDate;
  //   header2.font = { bold: true, size: 32 };
  //   header2.alignment = { horizontal: "center", vertical: "middle" };
  //   header2.fill = {
  //     type: "pattern",
  //     pattern: "solid",
  //     fgColor: { argb: "FFBDD7EE" }, // Light blue background
  //   };
  //   header2.border = {
  //     top: { style: "medium" },
  //     left: { style: "medium" },
  //     bottom: { style: "medium" },
  //     right: { style: "medium" },
  //   };

  //   worksheet.getRow(4).height = 25;

  //   // Tambahkan header kolom
  //   const headers = [
  //     "TANGGAL",
  //     "NOMOR AKUN",
  //     "NAMA AKUN",
  //     "KETERANGAN",
  //     "KATEGORI",
  //     "AMOUNT",
  //   ];
  //   headers.forEach((header, index) => {
  //     const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
  //     cell.value = header;
  //     cell.font = { bold: false, size: 12 };
  //     cell.alignment = { horizontal: "center", vertical: "middle" };
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFBDD7EE" }, // Light blue background
  //     };
  //     cell.border = {
  //       top: { style: "medium" },
  //       left: { style: "medium" },
  //       bottom: { style: "medium" },
  //       right: { style: "medium" },
  //     };
  //   });

  //   data.forEach((item, rowIndex) => {
  //     const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
  //     row.getCell(1).value = item.tgl;
  //     row.getCell(2).value = item.noAcc;
  //     row.getCell(3).value = item.nameAcc;
  //     row.getCell(4).value = item.keterangan;
  //     row.getCell(5).value = item.kategori;
  //     row.getCell(6).value = item.amount;

  //     row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
  //     row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
  //     row.getCell(5).alignment = { horizontal: "center", vertical: "middle" };

  //     // Format untuk nilai angka (Debet, Kredit, Saldo)
  //     row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

  //     const capitalizeText = (text) =>
  //       text.replace(/\b\w/g, (char) => char.toUpperCase());

  //     row.getCell(5).value = capitalizeText(row.getCell(5).value);
  //     row.getCell(5).font = { bold: true, size: 12 };

  //     const borderStyle = {
  //       top: { style: "thin" },
  //       left: { style: "thin" },
  //       bottom: { style: "thin" },
  //       right: { style: "thin" },
  //     };

  //     // Loop through cells 1 to 5 and apply the border style
  //     for (let i = 1; i <= headers.length; i++) {
  //       row.getCell(i).border = borderStyle;
  //     }
  //   });

  //   // Atur lebar kolom
  //   worksheet.columns = [
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 25 },
  //     { width: 40 },
  //     { width: 20 },
  //     { width: 20 },
  //   ];

  //   // Generate file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(blob, `Laporan Transaksi Inhouse.xlsx`);
  // };

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  return (
    <div>
      {uploadVisible && (
        <UploadModal
          visible={uploadVisible}
          onClose={() => setUploadVisible(false)}
          onSuccess={getData} // ← panggil ulang data
          applicationId={uploadData.applicationId}
          nik={uploadData.nik}
          nama={uploadData.nama}
          nikPasangan={uploadData.nikPasangan}
          namaPasangan={uploadData.namaPasangan}
        />
      )}

      {contextHolder}

      <h1 className="text-[2.25rem] font-bold mb-8 text-gray-800 font-sans tracking-tight">
        APPLICATION ORDER LIST DF
      </h1>

      <div className="flex gap-4">
        <ButtonExportPDF onClick={exportPDF} />
        <ButtonExportExcel onClick={exportToExcel} />
      </div>
      <div className="flex justify-between">
        {
          /* <Button
          type="primary"
          size="large"
          // onClick={() => handleModal("add", {})}
          onClick={() => openAddModal()}
          // onClick={() => setModalType("add")}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button> */

          <div className="flex flex-wrap gap-4 mb-4">
            <Input
              allowClear
              placeholder="Cari berdasarkan NIK, Nama, atau Application ID"
              style={{ width: 300 }}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            <Select
              allowClear
              placeholder="Status"
              style={{ width: 200 }}
              value={filterStatus}
              onChange={(val) => setFilterStatus(val)}
              options={[
                { value: "precheck", label: "Pre-Check" },
                { value: "survey", label: "Survey In Progress" },
                { value: "reject", label: "Reject" },
              ]}
            />

            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Cabang"
              options={branchOptions}
              value={branch}
              onChange={(val) => setBranch(val)}
            />
            {/* 
            <DatePicker.RangePicker
              format="DD/MM/YYYY"
              value={dateRange}
              onChange={(val) => setDateRange(val)}
              style={{ width: 300 }}
            /> */}
            {/* 
            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Status"
              options={statusOptions}
              value={status}
              onChange={(val) => setStatus(val)}
            /> */}

            <Button
              type="primary"
              onClick={() => getData()}
              className="bg-blue-600 text-white"
            >
              Filter
            </Button>
          </div>
        }
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          className={styles.customTable}
          columns={extendedColumn}
          loading={loading}
          // dataSource={data}
          dataSource={data
            .filter((item) => {
              const keyword = searchText.toLowerCase();
              return (
                item.nik?.toLowerCase().includes(keyword) ||
                item.nama?.toLowerCase().includes(keyword) ||
                item.application_id?.toLowerCase().includes(keyword)
              );
            })
            .filter((item) => {
              if (!filterStatus) return true;
              if (filterStatus === "precheck") return item.is_survey == null;
              if (filterStatus === "survey") return item.is_survey === 1;
              if (filterStatus === "reject") return item.is_survey === 0;
              return true;
            })}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          onChange={(pag) => setPagination(pag)}
        />
      </ConfigProvider>

      <ModalAddInhouse
        key={isAddOpen ? "add" : "hidden"}
        visible={isAddOpen}
        onClose={closeModal}
        title="Tambah Transaksi"
        // content={renderContent()}
        onSave={handleSubmit}
      />

      {/* Modal View */}
      <CustomModal
        key={modalType === "pasangan" && true}
        visible={modalType && modalType === "pasangan"}
        onClose={closeModal}
        title="Detail Pasangan"
        content={renderContent()}
        showFooter={false} // No buttons for View mode
        readOnly={true} // Form is read-only
      />
    </div>
  );
};

export default orderlistDF;
